// frontend/src/lib/supabaseClient.js
//
// EQUDX/EQUDXLIS now authenticates through the backend JWT API backed by
// Postgres. This file intentionally exports a no-network Supabase compatibility
// shim so legacy screens that still import `supabase` do not crash or attempt
// to refresh old Supabase browser sessions.

function emptyResult(data = []) {
  return Promise.resolve({ data, error: null, count: Array.isArray(data) ? data.length : null });
}

function makeQueryBuilder() {
  const builder = {
    select() { return builder; },
    insert() { return emptyResult(null); },
    update() { return builder; },
    upsert() { return emptyResult(null); },
    delete() { return builder; },
    eq() { return builder; },
    neq() { return builder; },
    in() { return builder; },
    is() { return builder; },
    order() { return emptyResult([]); },
    limit() { return builder; },
    single() { return emptyResult(null); },
    maybeSingle() { return emptyResult(null); },
    then(resolve, reject) { return emptyResult([]).then(resolve, reject); },
    catch(reject) { return emptyResult([]).catch(reject); },
    finally(cb) { return emptyResult([]).finally(cb); },
  };
  return builder;
}

function makeShim() {
  return {
    auth: {
      async getSession() { return { data: { session: null }, error: null }; },
      async getUser() { return { data: { user: null }, error: null }; },
      async signOut() { return { error: null }; },
      onAuthStateChange() { return { data: { subscription: { unsubscribe() {} } } }; },
    },
    from() { return makeQueryBuilder(); },
    storage: {
      from() {
        return {
          async upload() { return { data: null, error: new Error("Supabase storage is disabled; use backend file APIs.") }; },
          async remove() { return { data: null, error: null }; },
          getPublicUrl() { return { data: { publicUrl: "" } }; },
        };
      },
    },
    channel() {
      return { on() { return this; }, subscribe() { return { unsubscribe() {} }; } };
    },
    removeChannel() {},
  };
}

export const supabase = makeShim();
